export default class Parte{
    CodiceFornitore;
    CodiceParte;
    DescrParte;
    Marca;
    Modello;
    Matricola;
    Obsoleta;
    
    constructor(){}
}